/* eslint-disable no-debugger */
import { useEffect } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import { navLinks } from '../UseMemberAdministration';

import useMemberAdministrationLscEmailData from '@usas/ui-web/state/memberAdministration/lscEmail/UseMemberAdministrationLscEmailData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';

const useLSCRoleEmails = () => {
  const navigate = useNavigate();
  const { memberAdministrationLscRoleEmailsState, getLscRoleEmails, deleteLscRoleEmail, confirmSave } = useMemberAdministrationLscEmailData();
  const { selectOrgUnitState } = useSelectOrgUnitData();

  const onAddRoleEmail = () => {
    navigate(navLinks.LSC_EMAILS_ADD, { state: { activeUserOrgUnitId: selectOrgUnitState.orgUnitId } });
  };

  const onEditRoleEmail = (e, orgUnitOrgRoleFieldId) => {
    navigate(navLinks.LSC_EMAILS_EDIT, { state: { orgUnitOrgRoleFieldId, activeUserOrgUnitId: selectOrgUnitState.orgUnitId } });
  };

  const onDeleteRoleEmail = (e, orgUnitOrgRoleFieldId) => {
    e?.stopPropagation();
    deleteLscRoleEmail(orgUnitOrgRoleFieldId);
  };    

  useEffect(() => {
    if (selectOrgUnitState.orgUnitId) {
      if (memberAdministrationLscRoleEmailsState.isSaved === true) {
        confirmSave();
      } else {
        getLscRoleEmails(selectOrgUnitState.orgUnitId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectOrgUnitState.orgUnitId, memberAdministrationLscRoleEmailsState.isSaved]);

  return {
    isLoading: memberAdministrationLscRoleEmailsState.isArrayLoading || memberAdministrationLscRoleEmailsState.isSaving,
    memberAdministrationLscRoleEmailsState,
    onAddRoleEmail,
    onEditRoleEmail,
    onDeleteRoleEmail
  };
};

export default useLSCRoleEmails;